import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LandingNav = () => {
  const { t } = useTranslation();

  return (
    <nav className="landing-nav" style={{ display: "flex", width: "100%", background: "#00d4b3", position: "relative", zIndex: 10 }}>
      <Link to="/">{t("header.home")}</Link>
      <div className="landing-nav-dropdown">
        <span className="landing-nav-dropdown-trigger">{t("header.explore")}</span>
        <div className="landing-nav-dropdown-menu">
          <Link to="/about">{t("header.exploreMenu.about")}</Link>
          <Link to="/sulhafa-connect">{t("header.exploreMenu.connect")}</Link>
          <Link to="/sulhafa-care">{t("header.exploreMenu.care")}</Link>
          <Link to="/about/sulhafa-shop">{t("header.exploreMenu.shop")}</Link>
        </div>
      </div>
      <Link to="/our-partners">{t("header.ourPartners")}</Link>
      <Link to="/contact">{t("header.contact")}</Link>
    </nav>
  );
};

export default LandingNav;
